import { render } from "./VerDatosPersona.vue?vue&type=template&id=386e2e5d"
import script from "./VerDatosPersona.vue?vue&type=script&lang=js"
export * from "./VerDatosPersona.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__